import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _Exportations, _ImportCostSettlement, _ImportDeclaration, _NationalizationProcessGeneralInfo, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { SelectTHConstantsValue } from "../../../../config/Componentes/SelectTHConstantsValue";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const CETD001 = ({ configProcedure }: Props) => {

    const cedtdo = useDataBean(_NationalizationProcessGeneralInfo);
    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(cedtdo.bean)
        }

        if (configProcedure?._pushProps) {
            let x = {
                IDNationalizationProcessGeneralInfo: cedtdo.bean.IDNationalizationProcessGeneralInfo,
                State: 1

            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(cedtdo.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        cedtdo.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItem()
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        cedtdo.update().then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">
            <div className="col-md-12">


                <div className="row">
                    <div className="col-md-6">
                        <label>Tipo de deposito</label>
                        <SelectTHConstantsValue code={302} value={cedtdo.bean.DepositType} onChange={(e: any) => { cedtdo.setBean({ ...cedtdo.bean, "DepositType": e }) }}></SelectTHConstantsValue>
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-6">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={create}>Guardar Datos*</BasicButton>
                    </div>
                </div>
            </div>
        </div>
    )
}